import { Box, BoxProps, Button, Grid, Stack, Typography } from "@mui/material";
import { DadosTitulosItems } from "..";
import { IDataDetalharTitulosReceber } from "../../../../../../../types/api/financeiro/datalhar-titulos-receber";
import { verificarStringVazia } from "../../../../../../../helpers/verificadores";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { useState } from "react";
import DialogEdit from "./DialogEdit";
import { usePermission } from "../../../../../../../components/PermissionGuard";

export default function CardDadosTitulo({ boxStyle, detalhe, codigo }: CardDadosTituloProps) {

    const podeEditar = usePermission('financeiro.contas-receber-editar');

    const [openEdit, setOpenEdit] = useState(false)

    return (
        <Box {...boxStyle}>
            <Typography variant="h6">Dados do título</Typography>

            <Grid container rowGap={2}>
                <Grid size={{xs: 6}}>
                    <DadosTitulosItems titulo="Público" valor={`${detalhe.publico?.tipo_publico}${detalhe.publico?.codigo_publico} - ${detalhe.publico?.nome_pessoa}`} />
                </Grid>

                <Grid size={{xs: 6}} >
                    <DadosTitulosItems titulo="Fazenda" valor={detalhe.fazenda ? `${detalhe.fazenda.apelido} - ${detalhe.fazenda.nome}` : "-"} />
                </Grid>

                <Grid size={{xs: 6}}>
                    <DadosTitulosItems titulo="Tipo" valor={detalhe.tipo ? `${detalhe.tipo.codigo} - ${detalhe.tipo.nome}` : "-"} />
                </Grid>

                <Grid size={{xs: 6, md: 3}}>
                    <DadosTitulosItems titulo="Departamento" valor={detalhe.departamento ? `${detalhe.departamento.id} - ${detalhe.departamento.nome}` : "-"} />
                </Grid>

                <Grid size={{xs: 6, md: 3}}>
                    <DadosTitulosItems titulo="Função" valor={detalhe.funcao ? `${detalhe.funcao.id} - ${detalhe.funcao.nome}` : "-"} />
                </Grid>

                <Grid size={{xs: 6, md: 3}}>
                    <DadosTitulosItems titulo="Categoria" valor={detalhe.categoria ? `${detalhe.categoria.id} - ${detalhe.categoria.nome}` : "-"} />
                </Grid>

                <Grid size={{xs: 6, md: 3}}>
                    <DadosTitulosItems titulo="Local de cobrança" valor={detalhe.local_cobranca ? `${detalhe.local_cobranca.codigo} - ${detalhe.local_cobranca.nome}` : "-"} />
                </Grid>

                <Grid size={{xs: 6}}>
                    <DadosTitulosItems titulo="Situação" valor={detalhe.situacao ? `${detalhe.situacao.id} - ${detalhe.situacao.nome}` : "-"} />
                </Grid>

                <Grid size={{xs: 6}}>
                    <DadosTitulosItems titulo="Objeto" valor={verificarStringVazia(detalhe.objeto)} />
                </Grid>

                <Grid size={{xs: 6}}>
                    <DadosTitulosItems titulo="Histórico" valor={verificarStringVazia(detalhe.historico)} />
                </Grid>
            </Grid>

            {
                podeEditar &&
                <Stack direction="row" justifyContent="flex-end">
                    <Button
                        variant="contained"
                        size="small"
                        startIcon={<EditOutlinedIcon />}
                        sx={{ fontSize: '0.75rem' }}
                        onClick={() => setOpenEdit(true)}
                    >
                        Editar
                    </Button>
                </Stack>
            }

            {
                openEdit &&
                <DialogEdit
                    {...{ codigo }}
                    open={openEdit}
                    handleClose={() => setOpenEdit(false)}
                    titulo={detalhe}
                />
            }
        </Box>
    )
}

interface CardDadosTituloProps {
    boxStyle: BoxProps,
    codigo: string,
    detalhe: IDataDetalharTitulosReceber
}